import { DEVICE_OS, getDeviceOS } from '@autopass-web/domain';

import iconAppStore from '../../../../domain/assets/appstore.svg';
import mochiLogo from '../../../../domain/assets/autopassapp.svg';
import iconGooglePlay from '../../../../domain/assets/googleplay.svg';
import styles from './index.module.sass';

interface DownloadAppBarProps {
  onClick: () => void;
}

const DownloadAppBar = ({ onClick }: DownloadAppBarProps) => {
  const isIOS = getDeviceOS() === DEVICE_OS.IOS;

  const DistIcon = () => {
    if (isIOS) {
      return (
        <div className={styles['dist-name']}>
          <img src={iconAppStore} alt="app-store" />
          App Store
        </div>
      );
    } else {
      return (
        <div className={styles['dist-name']}>
          <img src={iconGooglePlay} alt="google-play" />
          Google Play
        </div>
      );
    }
  };

  const distLink = isIOS
    ? 'https://apps.apple.com/app/apple-store/id1332581201?pt=118939050&ct=self-fueling-web&mt=8'
    : 'https://play.google.com/store/apps/details?id=com.pklotcorp.autopass&referrer=utm_source%3Dself-fueling-web';

  return (
    <a
      className={styles['download-app-bar']}
      onClick={onClick}
      href={distLink}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div>
        <img src={mochiLogo} alt="logo" className={styles.logo} />
        <div className={styles['app-info']}>
          <div className={styles.text}>
            <DistIcon />
            <div className={styles['app-name']}>車麻吉</div>
            <div className={styles['app-desc']}>
              整合地圖導航 × 加油停車支付
            </div>
          </div>
        </div>
      </div>
      <button>下載</button>
    </a>
  );
};

export default DownloadAppBar;
